import { ClientRepresentedEvent, ServerRepresentedEvent } from './event.model'

/**
 * EventConvertHook Class usage under development - Keeping it for future reference
 */
export abstract class EventConvertHook {
  /** Method that will be executed before converting to a server represented event */
  abstract beforeConvertingToServerRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent
  /** Method that will be executed after converting to a server represented event */
  abstract afterConvertingToServerRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent
  /** Method that will be executed before converting to a client represented event */
  abstract beforeConvertingToClientRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent
  /** Method that will be executed after converting to a client represented event */
  abstract afterConvertingToClientRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent
}
